var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"script-pack-items-container"},[_c('section',{staticClass:"script-pack-items-scripts"},[_c('h5',[_vm._v("Scripts")]),_c('router-link',{attrs:{"to":{
      name: 'add-script'
    }}},[_c('button',{staticClass:"btn"},[_vm._v("New script")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }